import _ from 'underscore';

var unbindModels = function(models, options) {
    _.each(models, function(model) {
        model.off('sync', options.finalSuccess);
        model.off('error', options.finalError);
    });
};

var bindModels = function(models, options) {
    _.each(models, function(model) {
        model.on('sync', options.finalSuccess);
        model.on('error', options.finalError);
    });
};

var fetchModels = function(models, options) {
    _.each(models, function(model) {
        model.fetch(options);
    });
};

var fetch = function(models, success, error, options) {
    models = models || [];
    options = options || {};

    if (models.length === 0) {
        _.defer(function() {
            success && success();
        });
        return;
    }

    options.finalSuccess = _.after(models.length, function() {
        unbindModels(models, options);
        success && success();
    });

    options.finalError = function(model, err) {
        unbindModels(models, options);
        var retry = function() {
            _.defer(function() {
                bindModels(models, options);
                fetchModels([model], options);
            });
        };
        error && error(model, err, retry);
    };

    bindModels(models, options);
    fetchModels(models, options);
};

export default {
    fetch: fetch
};


